// extracted by mini-css-extract-plugin
module.exports = {"root":"pagination_root__AhiNR","pages":"pagination_pages___hb4X","previous":"pagination_previous__2JiXS","next":"pagination_next__1o6Xd"};